import React, { useContext, useEffect, useState } from 'react';
import { FaChevronDown, FaCoins, FaCross, FaHeart, FaRegUser } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
import styles from './MainHeaderRedemption.module.css';
import { MdLogout, MdOutlineMenu, MdShoppingCart } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import AuthContext from '../../Store/AuthContext';
import { BASE_URL_API } from '../../References/URLs';

const MainHeaderRedemption = (props) => {
    const { cartItems } = props
    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const location = useLocation();
    const { storeKey } = useParams();
    const authCtx = useContext(AuthContext);
    let isLoggedIn = authCtx?.isLoggedIn;
    const loginData = authCtx?.loginData ? JSON.parse(authCtx.loginData) : null;
    const userIdentifier = (() => { try { return JSON.parse(authCtx?.loginData)?.userIdentifier || null } catch { return null } })();


    // Set theme color meta tag
    useEffect(() => {
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (metaThemeColor) {
            metaThemeColor.setAttribute("content", "#ffffff");
        } else {
            const meta = document.createElement("meta");
            meta.name = "theme-color";
            meta.content = "#ffffff";
            document.head.appendChild(meta);
        }

        return () => {
            document.body.style.overflowY = "auto";
        };
    }, []);

    // Open slider and push state
    const toggleSlider = () => {
        setIsSliderOpen((prev) => {
            const newIsSliderOpen = !prev;
            document.body.style.overflowY = newIsSliderOpen ? "hidden" : "auto";

            if (newIsSliderOpen) {
                window.history.pushState({ sliderOpen: true }, ""); // Push a state
            } else if (window.history.state?.sliderOpen) {
                window.history.back(); // Revert to previous state
            }

            return newIsSliderOpen;
        });
    };

    // Close slider on route change
    useEffect(() => {
        setIsSliderOpen(false);
        document.body.style.overflowY = "auto"; // Re-enable scrolling
    }, [location]);

    // Handle back navigation to close slider
    useEffect(() => {
        const handlePopState = () => {
            if (isSliderOpen) {
                setIsSliderOpen(false);
                document.body.style.overflowY = "auto"; // Ensure scroll is enabled
            }
        };

        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isSliderOpen]);


    const [pointsData, setPointsData] = useState({
        "userIdentifier": null,
        "totalCredit": 0,
        "totalDebit": 0,
        "availablePoints": 0
    })


    const getPointsSummary = async () => {
        const getPointsSummaryResponse = await fetch(BASE_URL_API + "getPointsSummary",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: userIdentifier
                })
            });

        if (!getPointsSummaryResponse.ok) {
            console.log("Something went wrong : Server Error!")
        } else {
            const getPointsSummaryRespo = await getPointsSummaryResponse.json()
            if (getPointsSummaryRespo.status === "success") {
                setPointsData(getPointsSummaryRespo.response)
            } else {
                if (getPointsSummaryRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(getPointsSummaryRespo)
        }
    }

    useEffect(() => {
        getPointsSummary()
    }, [])
    

    return (
        <>
            <div className={styles.homeHeader}>
                <div className={styles.homeHeaderContainer}>
                    <Link to={`/tsc`} className={styles.hhcLeft}>
                        <img src="https://stylelink.s3.ap-south-1.amazonaws.com/qnnox-assets/web/logo-black.svg" alt="Logo" />
                    </Link>

                    <div className={`${styles.hhcCentre} ${isSliderOpen ? styles.hideOnMobile : ''}`}>
                        <div className={styles.hhcCentreContainer}>
                            <div className={styles.eachNavWrapper}>
                                <Link to={`/tsc/shop`}>Shop Now</Link>
                            </div>
                            <div className={styles.eachNavWrapper}>
                                <Link to={`/redeem`}>Redeem Now</Link>
                            </div>
                        </div>
                    </div>

                    {isLoggedIn ? (
                        <div className={styles.hhcRight}>
                            <div className={styles.cartIconWrapper}>
                                {cartItems?.length > 0 &&
                                    <div className={styles.itemsInCart}>{cartItems?.length}</div>
                                }
                                <Link to={`/redeem/cart`} className={styles.cartBtn}>
                                    <MdShoppingCart size={22} />
                                </Link>
                            </div>
                            {/* <div className={styles.cartIconWrapper}>
                                {cartItems?.length > 0 &&
                                    <div className={styles.itemsInCart}>{cartItems?.length}</div>
                                }
                                <Link to={`/${storeKey}/cart`} className={styles.cartBtn}>
                                    <FaHeart size={22} />
                                </Link>
                            </div> */}
                            <div className={styles.availablePoints}>
                                <FaCoins size={14} />{pointsData?.availablePoints}
                            </div>
                            <Link to={`/user/profile`} className={styles.logoutBtn}>
                                <FaRegUser size={18} />
                            </Link>
                            <MdOutlineMenu size={30} onClick={toggleSlider} className={styles.menuIcon} />
                        </div>
                    ) : (
                        <div className={styles.hhcRight}>
                            <Link to={`/login`}>Login</Link>
                            <MdOutlineMenu size={30} onClick={toggleSlider} className={styles.menuIcon} />
                        </div>
                    )}
                </div>
            </div>

            {isSliderOpen && (
                <div
                    className={`${styles.mobileSlider} ${isSliderOpen ? styles.open : ''}`}
                    onClick={toggleSlider}
                >
                    <div className={styles.sliderContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.closeBtn} onClick={toggleSlider}>
                            <RxCross1 size={28} />
                        </div>
                        <div className={styles.msNavWrapper}>
                            <div className={styles.msNavTitle}>
                                <div>Earn Points</div>
                            </div>
                            <div className={styles.msSubMenu}>
                                <Link to={`/tsc/shop`}>Shop Now</Link>
                                <Link to={`/qr-scanning`}>Qr scanning</Link>
                                <Link to={`/influencer-loyalty`}>Bill Uploading</Link>
                            </div>
                        </div>
                        <div className={styles.msNavWrapper}>
                            <div className={styles.msNavTitle}>
                                <div>Redeem Points</div>
                            </div>
                            <div className={styles.msSubMenu}>
                                <Link to={`/redeem`}>Redeem Now</Link>
                            </div>
                        </div>
                        <div className={styles.msNavWrapper}>
                            <div className={styles.msNavTitle}>
                                <div>Profile</div>
                            </div>
                            <div className={styles.msSubMenu}>
                                <Link to={`/user/profile`}>Profile</Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default MainHeaderRedemption;
